export default "__VITE_ASSET__ik6Ob1yG__"